import { letterList, letterTemplateContent } from "constants/letter";
import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";

export const createLetter = async (bodyData) => {
  try {
    const res = await api.create_letter(bodyData);
    return res;
  } catch (error) {
    authorizedUser(error?.response?.data);
    if (error.response?.data instanceof Blob) {
      const text = await error.response.data.text();
      const json = JSON.parse(text);
      return json;
    }
    return error.response?.data || error;
  }
};

export const updateLetter = async (id, bodyData) => {
  try {
    const res = await api.update_letter(id, bodyData);
    return res;
  } catch (error) {
    authorizedUser(error?.response?.data);
    if (error.response?.data instanceof Blob) {
      const text = await error.response.data.text();
      const json = JSON.parse(text);
      return json;
    }
    return error.response?.data || error;
  }
};

export const getLetterList = async (
  dispatch,
  pageNum,
  filterParams,
  searchString,
  userID,
) => {
  try {
    const res = await api.letter_list(
      pageNum,
      filterParams,
      searchString,
      userID,
    );
    dispatch({ type: letterList, payload: res.data });
  } catch (error) {
    authorizedUser(error?.response?.data);
    dispatch({
      type: letterList,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};

export const downloadLetterQR = async (id) => {
  try {
    const res = await api.download__letter_qr(id);
    return res;
  } catch (error) {
    authorizedUser(error?.response || error?.response?.data);
    if (error.response && error.response.data instanceof Blob) {
      const text = await error.response.data.text();
      const json = JSON.parse(text);
      return json;
    }

    return (
      error.response?.data || {
        code: 500,
        status: "FAILED",
        message: "Failed to download QR code. Please try again.",
      }
    );
  }
};

export const downloadLetter = async (id) => {
  try {
    const res = await api.download_letter(id);
    return res;
  } catch (error) {
    authorizedUser(error?.response);
    if (error.response && error.response.data instanceof Blob) {
      const text = await error.response.data.text();
      const json = JSON.parse(text);
      return json;
    }

    return (
      error.response?.data || {
        code: 500,
        status: "FAILED",
        message: "Failed to download letter. Please try again.",
      }
    );
  }
};

export const getLetterTemplateContent = async (dispatch, filterParams) => {
  try {
    const res = await api.get_letter_template_content(filterParams);
    dispatch({
      type: letterTemplateContent,
      payload: res?.data,
    });
  } catch (error) {
    authorizedUser(error?.response || error?.response?.data);
    dispatch({
      type: letterTemplateContent,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};

export const getLetterByID = async (id) => {
  try {
    const res = await api.get_letter_by_ID(id);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const deleteLetterUser = async (letterUserID) => {
  try {
    const res = await api.delete_letter_user(letterUserID);
    return res?.data
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error
  }
}

export const requestLetterApproval = async (id) => {
  try {
    const res = await api.request_letter_approval(id);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const generateFinalLetter = async (id) => {
  try {
    const res = await api.generate_final_letter(id);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const deleteLetter = async (id) => {
  try {
    const res = await api.delete_letter(id);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};


export const deleteToolItems = async (letterId, bodyData) => {
  try {
    const res = await api.delete_tool_items(letterId, bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
}